export enum FeatureFlag {
  AI_REPORT_GENERATION_SWITCHER = 'ai-report-generation-switcher',
  AI_REPORT_GENERATE_BUTTON = 'ai-report-generate-button',
  REPORT_MARK_AS_COMPLETE_BUTTON = 'report-mark-as-complete-button',
  AI_CHATBOT = 'ai-chatbot',
  MATERIALITY_EVALUATION_ROUTES = 'materiality-evaluation-routes',
  CSV_DATA_EXPORT = 'csv-data-export',
}
